module.exports = __webpack_public_path__ + "static/assets/2d96b207399b06aa8fd389bb44cfbdb4.svg";